class SectionsApi {
    constructor(api) {
        this.api = api;
    }

    findByUrl(url, search = null) {
        const jsonUrl = url.match(/\.json$/) === null ? `${url}.json` : url;
        return this.api.requestGet(jsonUrl, search, {
            withSession: true,
        });
    }

    get(query = {}, page = 1, count = 10) {
        const { section = null, listType = null, edition = null, ...props } = query || {};

        let route = this.api.route('section.json', { section });

        if (listType !== null && edition !== null) {
            route = this.api.route('section_with_type_and_edition.json', {
                section,
                edition,
                list_type: listType,
            });
        } else if (edition !== null) {
            route = this.api.route('section_with_edition.json', { section, edition });
        }

        const finalQuery = {
            ...props,
        };
        if (page !== null) {
            finalQuery.page = page;
        }
        if (count !== null) {
            finalQuery.count = count;
        }
        return this.api.requestGet(route, finalQuery, {
            withSession: true,
        });
    }
}

export default SectionsApi;
